export default {
  stickyTitle: 'Stickies',
  confirmSubmit: 'Questions prefilled with sticky responses. Please confirm you have reviewed.',
  review: 'REVIEW',
  submit: 'SUBMIT'
};